import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download-small",
  "use": "download-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"download-small\">\n  <path d=\"M4.007 7.172L7.5 9.473V1h1v8.473l3.493-2.301.007.01v1.183L8 11 4 8.365V7.182l.007-.01zM11.5 4v1.036c.847.189 1.684.421 2.5.731L14.083 13H2V5.767c.816-.31 1.653-.542 2.5-.732V4c-1.212.256-2.384.62-3.5 1.091v8.66C3.153 14.555 5.518 15 8 15c2.483 0 4.848-.445 7-1.249v-8.66C13.884 4.62 12.712 4.256 11.5 4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol